import React, { Component } from 'react';
import './styles.scss';
import { BrowserRouter } from 'react-router-dom';
import { Layout } from 'antd';
import { ProtectedRoute } from './protected.route';

import FooterBar from './components/FooterBar';
import HeaderMenu from './components/HeaderMenu';

import Devices from './routes/devices';
import TestPlans from './routes/testplans';

import Reports from './routes/reports';
import Labels from './routes/labels';
import Wizard from './routes/wizard';
import DatabaseBrowser from './routes/database';
import Settings from './routes/settings';
import Logs from './routes/logs';
import About from './routes/about';
import Barcode from './routes/barcode';

// Required by antd
const { Content, Footer, Header } = Layout;

class App extends Component {
    state = {
        advance: false
    };

    handleAdvance = () => {
        this.setState({ advance: true });
    };

    render() {
        return (
            <BrowserRouter>
                <Layout style={{ height: '100vh' }}>
                    <Header id="header-e">
                        <HeaderMenu advance={this.state.advance} />
                    </Header>
                    <Layout>
                        <Content id="content">
                            <ProtectedRoute exact path="/" component={Devices} />
                            {/* <ProtectedRoute exact path="/" component={Settings} /> */}
                            <ProtectedRoute exact path="/testplans" component={TestPlans} />
                            <ProtectedRoute exact path="/wizard/:id" component={Wizard} />
                            <ProtectedRoute exact path="/wizard/new/:template" component={Wizard} />
                            <ProtectedRoute exact path="/wizard" component={Wizard} />
                            <ProtectedRoute exact path="/reports" component={Reports} />
                            <ProtectedRoute exact path="/labels" component={Labels} />
                            <ProtectedRoute exact path="/database" component={DatabaseBrowser} />
                            <ProtectedRoute exact path="/settings" component={Settings} />
                            <ProtectedRoute exact path="/logs" component={Logs} />
                            <ProtectedRoute
                                exact
                                path="/about"
                                handleAdvance={this.handleAdvance}
                                component={About}
                            />
                            <ProtectedRoute exact path="/barcode" component={Barcode} />
                        </Content>
                        <Footer style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                            <FooterBar />
                        </Footer>
                    </Layout>
                </Layout>
            </BrowserRouter>
        );
    }
}

export default App;
